import Config from "../config/app-configuration";
import ApiClient from "./apiClient";

/* global Excel, Office, OfficeRuntime */
export class FileOutlookServer {

    static async getOBOToken(token) {
        const serviceUrl = `${Config.msGraphAddonUrl}/${Config.serviceUrls.getOutlookGraphToken}`;
        const requestHeaders = { ...Config.headers };
        delete requestHeaders.ownerid;
        delete requestHeaders.teamid;
        delete requestHeaders.refreshToken;

        return ApiClient.fetchPostCall(serviceUrl, { token }, requestHeaders)
            .then(res => res.json())
            .then(function (data) {
                return data;
            })
            .catch(function (error) {
                console.log(error)
            })
    }

    static async fetchFilesFromOutlookServer(filesArray) {
        if (!Office.context.mailbox || !Office.context.requirements.isSetSupported('Mailbox', '1.5')) {
            return [];
        }
        try {
            const accessToken = await OfficeRuntime.auth.getAccessToken({ allowConsentPrompt: true, allowSignInPrompt: true });
            const userTokenFromAccessToken = await this.getOBOToken(accessToken);
            const oboToken = userTokenFromAccessToken.accessToken;
            const ewsId = Office.context.mailbox.item.itemId;
            const restId = Office.context.mailbox.convertToRestId(ewsId, Office.MailboxEnums.RestVersion.v2_0);

            const fetchAttachment = async (eachFile) => {
                try {
                    const attachmentId = Office.context.mailbox.convertToRestId(eachFile.id, Office.MailboxEnums.RestVersion.v2_0);
                    const attachmentUrl = `${Config.graphApiBaseUrl}/v1.0/me/messages/${restId}/attachments/${attachmentId}`;
                    const response = await fetch(attachmentUrl, {
                        method: "GET",
                        headers: { 'Authorization': `Bearer ${oboToken}` }
                    });
                    if (!response.ok) {
                        throw { status: response.status, statusText: response.statusText };
                    }
                    const res = await response.json();
                    const data = new Buffer(res.contentBytes, 'base64');
                    const file = new Blob([data], { type: res.contentType });
                    file.name = res.name;
                    return file;
                } catch (error) {
                    console.log(`Error fetching file attachments: ${error}`)
                    throw { status: error.status || 400, statusText: error.statusText || "Error fetching the attachment" };
                }
            };

            const files = await Promise.all(filesArray.map(fetchAttachment));
            return files;
        } catch (error) {
            console.error("Failed to get access token or fetch attachments:", error);
            throw {
                status: error.status || 401,
                statusText: error.statusText || "Failed to get access token or fetch attachments",
                error: error
            };
        }
    }
}

export default FileOutlookServer;